<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal" style="z-index: 99999;">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content"
                         style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal"
                               v-text="'View Distribution'"></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg"
                                     alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content"
                                 style="overflow: visible">
                                <div class="row mt-2 pl-2 pr-2">
                                    <div class="col-md-12">
                                        <TextField
                                            v-model="title"
                                            name="title"
                                            label="Title"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <TextareaField
                                            v-if="distribution_type.length > 110"
                                            v-model="distribution_type"
                                            name="description"
                                            label="Description (optional)"
                                            rows="5"
                                            disabled
                                        />
                                        <TextField
                                            v-else
                                            v-model="distribution_type"
                                            name="description"
                                            label="Description (optional)"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <TextareaField
                                            v-if="description.length > 110"
                                            v-model="description"
                                            name="description"
                                            label="Description (optional)"
                                            rows="5"
                                            disabled
                                            class="mb-3"
                                        />

                                        <TextField
                                            v-else
                                            v-model="description"
                                            name="description"
                                            label="Description (optional)"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-md-12">
                                        <TextField
                                            v-model="redirect_url"
                                            name="redirect_url"
                                            label="Redirect URL (optional)"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-5">
                                    <button v-text="'Close'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="closeModal">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from "@/commons/FormElements/TextareaField.vue";

export default {
    name: "ModalViewDistribution",
    components: {TextareaField, TextField},
    props: {
        campaignId: String,
        data: {
            type: Object,
            default: null
        },
        types: Array
    },
    data() {
        return {
            title: '',
            description: '',
            distribution_type: '',
            redirect_url: '',
        }
    },
    created() {
        if (this.data) {
            this.title = this.data.title;
            this.description = this.data.description;
            this.distribution_type = this.data.type.toString();
            this.redirect_url = this.data.redirect_url;
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
</style>
